
<div class="popup marginBottomStyle" 
    style="position: relative; overflow: hidden; height: 100%">
    <div >
        <label i18n="@@spmsUserReg" class="textColour">Filters For Dataset</label>
        <span class="example-spacer"></span>
        <p *ngIf="showVisualDropDowns" style="font-size: 14px;">Dataset Refresh Date : {{datasetLastRefreshedDate}}</p>
    </div>
    <div [ngStyle]="{'height': isExternalFilter ? '95%' : '88%', 'overflow': 'hidden'}">
        <div [ngClass]="{'ifNotExternal': !isExternalFilter}"  >
            <form novalidate [formGroup]="formValid" style="margin-bottom: 3em">
                <div class="container">
                    <div style="max-width: 0; max-height: 0; overflow: hidden">
                        <input autofocus="true" />
                    </div>
                    <div class="row topRowMargins" style="margin-bottom: 0;margin-top: 0.5rem;">
                        <!--  -->
                        <div class="col-lg-6" style="padding-left: 0;" *ngIf="!showVisualDropDowns && hideReportName">
                            <mat-form-field class="filter" appearance="outline">
                                <mat-label i18n="@@targetloginusername">
                                    Filters
                                </mat-label>
                                <mat-select formControlName="filter" multiple [(ngModel)]="selectedFilter"  (selectionChange)="onSelectionChanged($event)" [sortComparator]="noCompareFunction">
                                        <mat-option *ngFor="let tempObject of getdata" [value]="tempObject.filtermanageId" [disabled]="tempObject.status == 'No' || tempObject.isDisable">
                                            {{tempObject.filtername}}
                                        </mat-option>

                                </mat-select>
                               <mat-error *ngIf="formValid.get('filter')?.hasError('required') && formValid.get('filter')?.touched">
                                {{ formValid.get('filter')?.getError('message') || 'Filter is required' }}
                            </mat-error>


                            </mat-form-field>
                        </div>
                        <div class="col-lg-12" style="padding-left: 0;" *ngIf="!showVisualDropDowns && !hideReportName">
                            <mat-form-field class="filter" appearance="outline">
                                <mat-label i18n="@@targetloginusername">
                                    Filters
                                </mat-label>
                                <mat-select formControlName="filter" multiple [(ngModel)]="selectedFilter"  (selectionChange)="onSelectionChanged($event)" [sortComparator]="noCompareFunction">
                                        <mat-option *ngFor="let tempObject of getdata" [value]="tempObject.filtermanageId" [disabled]="tempObject.status == 'No' || tempObject.isDisable">
                                            {{tempObject.filtername}}
                                        </mat-option>

                                </mat-select>
                             <mat-error *ngIf="formValid.get('filter')?.hasError('required') && formValid.get('filter')?.touched">
                                {{ formValid.get('filter')?.getError('message') || 'Filter is required' }}
                            </mat-error>


                            </mat-form-field>
                        </div>
                        <div class="col-lg-6" style="padding-left: 0;padding-right: 0;" *ngIf="!showVisualDropDowns && hideReportName">
                            <mat-form-field class="filter" appearance="outline">
                                <mat-label i18n="@@TMSTAFFMASTERfirstname">Report Name</mat-label>
                                <input matInput type="text" placeholder="Report Name" formControlName="userReportName"
                                  [(ngModel)]="userReportName" maxlength="100">
                                  <mat-error *ngFor="let validation of validation_messages.reportname">
                                    <span *ngIf="formValid.get('userReportName').hasError(validation.type) && (formValid.get('userReportName').dirty || formValid.get('userReportName').touched)">{{validation.message}}</span>
                                  </mat-error>
                          </mat-form-field>
                        </div>
                        
                        <div class="col-lg-4" style="padding-left: 0;"*ngIf="showVisualDropDowns">
                            <mat-form-field class="filter" appearance="outline">
                                <mat-label i18n="@@targetloginusername">
                                    Filters
                                </mat-label>
                                <mat-select formControlName="filter" multiple [(ngModel)]="selectedFilter"  (selectionChange)="onSelectionChanged($event)" [sortComparator]="noCompareFunction">
                                        <mat-option *ngFor="let tempObject of getdata" [value]="tempObject.filtermanageId" [disabled]="tempObject.status == 'No' || tempObject.isDisable">
                                            {{tempObject.filtername}}
                                        </mat-option>

                                </mat-select>
                            <mat-error *ngIf="formValid.get('filter')?.hasError('required') && formValid.get('filter')?.touched">
                                {{ formValid.get('filter')?.getError('message') || 'Filter is required' }}
                            </mat-error>


                            </mat-form-field>
                        </div>
                        <div class="col-lg-4" style="padding-left: 0;" *ngIf="showVisualDropDowns && !hideReportName">
                            <mat-form-field class="filter" appearance="outline">
                                <mat-label i18n="@@targetloginusername">
                                  Select Visuals
                                </mat-label>
                                <mat-select formControlName="selectVisual" [(ngModel)]="selectedVisualId" (selectionChange)="onVisualSelectionChanged($event)"  [required]="showVisualDropDowns">
                                        <mat-option *ngFor="let tempObject of visualData"  [value]="tempObject.visualId">
                                            {{tempObject.visualName}}
                                        </mat-option>
                            </mat-select>
                            <mat-error *ngFor="let validation of validation_messages.selectVisual">
                                <span
                                    *ngIf="formValid.get('selectVisual').hasError(validation.type) && (formValid.get('selectVisual').dirty || formValid.get('selectVisual').touched)">
                                    {{ validation.message }}
                                </span>
                            </mat-error>
                            </mat-form-field>
                        </div>
                        <!-- (selectionChange)="onVisualTypeSelectionChanged($event)" -->
                        <div class="col-lg-4" style="padding-right: 0;" *ngIf="showVisualDropDowns">
                            <mat-form-field class="filter" appearance="outline">
                                <mat-label i18n="@@targetloginusername">
                                    Visual Type
                                </mat-label>
                                <mat-select formControlName="visualType" [(ngModel)]="visualType"   [disabled]="visualTypeDisabled">
                                        <mat-option *ngFor="let tempObject of visualTypeData" [value]="tempObject.visualTypeName">
                                            {{tempObject.visualTypeName}}
                                        </mat-option>

                                </mat-select>
                              
                            </mat-form-field>
                        </div>
                        
                    </div>
                    <div  *ngIf="isExternalFilter" class="row topRowMargins" style="margin-top: 0;">
                        <div class="col-lg-12" style="padding: 0;">
                            <app-rpm-search-filter [s3FilePath]="selectedExternalFilterS3Path" (sendSelectedData)="rmpFilterData($event)"></app-rpm-search-filter>
                        </div>
                    </div>
                   
                    <div *ngIf="!isExternalFilter" class="row topRowMargins" style="margin-top: 0;">
                        <div class="col-lg-12">
                            <div *ngFor="let filters of selectedFiltersList;index as i" >
                            <div  class="row topRowMargins" *ngIf="!filters.hideInVisuals" style="margin-top: 0;margin-bottom: 0;">
                                
                                <div class="col-lg-4" style="padding-left: 0;">
                                    <mat-form-field appearance="outline">
                                        <mat-label i18n="@@targetloginusername">
                                            Label
                                        </mat-label>
                                        <input matInput type="text" [formControlName]="'label'+i"  
                                            [(ngModel)]="filters.label" readonly="true" [title]="filters.label ? filters.label : '' "class="lable_field" />
                                    </mat-form-field>

                                </div>
                                <div class="col-lg-4" style="padding-left: 0;">
                                    <mat-form-field appearance="outline">
                                        <mat-label i18n="@@RCConditionalOperators">Condition</mat-label>
                                        <mat-select [(ngModel)]="filters.whereConditionValue" [formControlName]="'condition'+i" (selectionChange)="OnConditionChange($event,i)" [title]="filters.whereConditionValue ? filters.whereConditionValue : '' " [disabled]="filters.whereConditionValue == 'IN'">
                                          <mat-option *ngFor="let conditionalOperator of
                                            conditionalOperatorDataWhere" [(value)]="conditionalOperator.value" [disabled]="conditionalOperator.value == 'IN'|| conditionalOperator.value == 'NOT IN'">
                                            {{conditionalOperator.name}}
                                          </mat-option>
                                        </mat-select>
                                      </mat-form-field>

                                </div>
                                <div class="col-lg-4" style="padding-right: 0;padding-left: 0;">
                                    <div *ngIf="filters.whereCondition == 'BETWEEN'" style="display: inline-flex;
                                        justify-content: space-between; max-width: 100%;">
                                        <div  *ngIf="filters.type != 'DateTime' && filters.type != 'Date';else dateFieldValue1">
                                        <mat-form-field class="valueField" appearance="outline" style="width: 49%;">
                                            <mat-label i18n="@@RCEnterValue">Start Value</mat-label>
                                            <input matInput type="text" maxlength="50" [formControlName]="'value'+i"  
                                            [(ngModel)]="filters.whereValue" [title]="filters.whereValue ? filters.whereValue : '' ">
                                            <mat-error *ngFor="let validation of validation_messages.value">
                                                <span *ngIf="filters.mandatoryFilter 
                                                 && formValid.get('value'+i).hasError(validation.type) 
                                                 && (formValid.get('value'+i).dirty || formValid.get('value'+i).touched)">
                                                 {{ validation.message }}
                                                </span>
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                        <ng-template #dateFieldValue1>
                                            <mat-form-field appearance="outline" style="width: 49%;">
                                                <mat-label i18n="@@TMSTAFFMASTERLastname">Start Date</mat-label>
                                                <input matInput [(ngModel)]="filters.whereValue" [matDatepicker]="whereDate2" readonly 
                                                [formControlName]="'value'+i" [title]="filters.whereValue ? dateFormatForTitle(filters.whereValue) : '' " [required]="getFormatedDate(filters.whereValue1)">
                                                <mat-datepicker-toggle matSuffix [for]="whereDate2">
                                                  <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                                                </mat-datepicker-toggle>
                                                <mat-datepicker-toggle  class="clearIcon" matSuffix (click)="filters.whereValue = null">
                                                  <mat-icon matDatepickerToggleIcon title="Clear">clear</mat-icon>
                                              </mat-datepicker-toggle>
                                                <mat-datepicker #whereDate2></mat-datepicker>
                                                <mat-error *ngFor="let validation of validation_messages.value">
                                                    <span
                                                        *ngIf="formValid.get('value'+i).hasError(validation.type) && (formValid.get('value'+i).dirty || formValid.get('value'+i).touched)">
                                                        {{ validation.message }}
                                                    </span>
                                                </mat-error>
                                              </mat-form-field>
                                        </ng-template>
                                        <div *ngIf="filters.type != 'DateTime' && filters.type != 'Date';else dateFieldValue2">
                                        <mat-form-field class="valueField" appearance="outline" style="width: 49%;margin: auto;margin-left: 2%;">
                                            <mat-label i18n="@@RCEnterValue">End Value</mat-label>
                                            <input matInput type="text" maxlength="50" [formControlName]="'value1'+i"  
                                            [(ngModel)]="filters.whereValue1" [title]="filters.whereValue1 ? filters.whereValue1 : '' " >
                                        <mat-error *ngFor="let validation of validation_messages.value">
                                            <span *ngIf="filters.mandatoryFilter 
                                            && formValid.get('value1'+i).hasError(validation.type) 
                                            && (formValid.get('value1'+i).dirty || formValid.get('value1'+i).touched)">
                                            {{ validation.message }}
                                        </span>
                                    </mat-error>
                                        </mat-form-field>
                                    </div>
                                        <ng-template #dateFieldValue2>
                                            <mat-form-field appearance="outline" style="width: 49%;margin: auto;margin-left: 2%;">
                                                <mat-label i18n="@@TMSTAFFMASTERLastname">End Date</mat-label>
                                                <input matInput [(ngModel)]="filters.whereValue1" [matDatepicker]="whereDate2" readonly 
                                                [formControlName]="'value1'+i" [title]="filters.whereValue1 ? dateFormatForTitle(filters.whereValue1) : '' " [required]="getFormatedDate(filters.whereValue)" >
                                                <mat-datepicker-toggle matSuffix [for]="whereDate2">
                                                  <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                                                </mat-datepicker-toggle>
                                                <mat-datepicker-toggle  class="clearIcon" matSuffix (click)="filters.whereValue1 = null">
                                                  <mat-icon matDatepickerToggleIcon title="Clear">clear</mat-icon>
                                              </mat-datepicker-toggle>
                                                <mat-datepicker #whereDate2></mat-datepicker>
                                                <mat-error *ngFor="let validation of validation_messages.value">
                                                    <span
                                                        *ngIf="formValid.get('value1'+i).hasError(validation.type) && (formValid.get('value1'+i).dirty || formValid.get('value1'+i).touched)">
                                                        {{ validation.message }}
                                                    </span>
                                                </mat-error>
                                              </mat-form-field>
                                        </ng-template>
                                        </div>
                                        <div *ngIf="filters.whereCondition == 'IN'">
                                            <div *ngIf="filters.multiSelectVaules.length>0;else textfield">
                                            <mat-form-field appearance="outline">
                                              <mat-label i18n="@@RCFields">Select Values</mat-label>
                                              <input matInput type="text" [(ngModel)]="filters.whereValue" [(value)]="filters.whereValue"
                                              [formControlName]="'value'+i" (click)="searchableDropdown(filters)"  [title]="filters.whereValue ? filters.whereValue : '' " [readonly]="true">
                                              <!-- <mat-select [(ngModel)]="filters.whereValue" multiple [formControlName]="'value'+i" [title]="filters.whereValue ? filters.whereValue : '' ">
                                                <mat-option *ngFor="let field of filters.multiSelectVaules" [(value)]="field.alias">
                                                  {{field.alias}}
                                                </mat-option>
                                              </mat-select> -->
                                             <mat-error *ngFor="let validation of validation_messages.value">
                                                <span *ngIf="filters.mandatoryFilter 
                                                 && formValid.get('value'+i).hasError(validation.type) 
                                                 && (formValid.get('value'+i).dirty || formValid.get('value'+i).touched)">
                                                 {{ validation.message }}
                                                </span>
                                            </mat-error>
                                            </mat-form-field>
                                        </div>
                                        <ng-template #textfield>
                                            <mat-form-field appearance="outline">
                                                <mat-label i18n="@@targetloginusername">
                                                    Value
                                                </mat-label>
                                                <input matInput type="text" [formControlName]="'value'+i"  
                                                    [(ngModel)]="filters.whereValue" [title]="filters.whereValue ? filters.whereValue : '' "  />
                                                    <mat-error *ngFor="let validation of validation_messages.value">
                                                <span *ngIf="filters.mandatoryFilter 
                                                 && formValid.get('value'+i).hasError(validation.type) 
                                                 && (formValid.get('value'+i).dirty || formValid.get('value'+i).touched)">
                                                 {{ validation.message }}
                                                </span>
                                            </mat-error>
                                            </mat-form-field>
                                        </ng-template>
                                          </div>
                                          <div *ngIf="filters.whereCondition == 'MAX' || filters.whereCondition == 'MIN'">
                                            <mat-form-field appearance="outline">
                                              <mat-label i18n="@@RCFields">Select Values</mat-label>
                                              <input matInput type="text" [(ngModel)]="filters.whereValue" [(value)]="filters.whereValue"
                                              [formControlName]="'value'+i" (click)="searchableSingleSelectForAtributies(filters)"  [title]="filters.whereValue ? filters.whereValue : '' " [readonly]="true">
                                              <!-- <mat-select [(ngModel)]="filters.whereValue" multiple [formControlName]="'value'+i" [title]="filters.whereValue ? filters.whereValue : '' ">
                                                <mat-option *ngFor="let field of filters.multiSelectVaules" [(value)]="field.alias">
                                                  {{field.alias}}
                                                </mat-option>
                                              </mat-select> -->
                                             <mat-error *ngFor="let validation of validation_messages.value">
                                                <span *ngIf="filters.mandatoryFilter 
                                                 && formValid.get('value'+i).hasError(validation.type) 
                                                 && (formValid.get('value'+i).dirty || formValid.get('value'+i).touched)">
                                                 {{ validation.message }}
                                                </span>
                                            </mat-error>
                                            </mat-form-field>
                                          </div>
                                        <div *ngIf="filters.whereCondition != 'BETWEEN' && filters.whereCondition != 'IN' && filters.whereCondition != 'MAX' && filters.whereCondition != 'MIN'">
                                          <div *ngIf="filters.type != 'DateTime' && filters.type != 'Date';else dateField">
                                            <mat-form-field appearance="outline">
                                                <mat-label i18n="@@targetloginusername">
                                                    Value
                                                </mat-label>
                                                <input matInput type="text" [formControlName]="'value'+i"  
                                                    [(ngModel)]="filters.whereValue" [title]="filters.whereValue ? filters.whereValue : '' "  />
                                                   <mat-error *ngFor="let validation of validation_messages.value">
                                                <span *ngIf="filters.mandatoryFilter 
                                                 && formValid.get('value'+i).hasError(validation.type) 
                                                 && (formValid.get('value'+i).dirty || formValid.get('value'+i).touched)">
                                                 {{ validation.message }}
                                                </span>
                                            </mat-error>
                                            </mat-form-field>
                                        </div>
                                        <ng-template #dateField>
                                            <mat-form-field appearance="outline">
                                                <mat-label i18n="@@TMSTAFFMASTERLastname">Date</mat-label>
                                                <input matInput [(ngModel)]="filters.whereValue" [matDatepicker]="whereDate2" readonly 
                                                [formControlName]="'value'+i" [title]="filters.whereValue ? dateFormatForTitle(filters.whereValue) : '' ">
                                                <mat-datepicker-toggle matSuffix [for]="whereDate2">
                                                  <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                                                </mat-datepicker-toggle>
                                                <mat-datepicker-toggle  class="clearIcon" matSuffix (click)="filters.whereValue = null">
                                                  <mat-icon matDatepickerToggleIcon title="Clear">clear</mat-icon>
                                              </mat-datepicker-toggle>
                                                <mat-datepicker #whereDate2></mat-datepicker>
                                              </mat-form-field>
                                        </ng-template>

                                    
                                </div>
                                </div>
                                
                            </div>
                            </div>
                            </div>
                            
                        </div>
                    </div>
                </form>
            </div>
            </div>
            <div *ngIf="!isExternalFilter" class="row d-flex align-items-center" style= "position:sticky;left:0;bottom:0;width:100%">
                    <div class="col-lg-6" >
                        <div *ngIf="selectedFilter && selectedFilter.length <= 1" class="d-flex justify-content-end align-items-center gap-2">
                            <mat-icon aria-hidden="false" aria-label="Reset icon"  style="cursor: pointer; " (click)="onResetClicked($event)">restart_alt</mat-icon>
                            <span class="common-label">Reset</span>
                   
                        <mat-checkbox class="example-margin common-label" [(ngModel)]="isChecked" *ngIf="selectedFilter && selectedFilter.length <= 1">Save filters</mat-checkbox>
                    </div>
                    </div>
                    <div class="col-lg text-center" >
                        
                        <div *ngIf="selectedFilter" class="d-flex justify-content-center gap-2">
                            <button *ngIf="selectedFilter" i18n="@@TargetClear" type="button" (click)="sendDataAndClose()" [class.allocateButtons]="allocateButtonsBoolean" [class.allocateButtons1]="allocateButtons1Boolean"
                            class="w-50 actionButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                            style="padding-left:1.2rem;padding-right: 1.2rem;" [style.background-color]="backgroundColorButton">Proceed</button>
                
                            <button i18n="@@TargetCancel" type="button" (click)="closeFunction()"
                            class="w-50 cancelButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [class.allocateButtons]="allocateButtonsBoolean" [class.allocateButtons1]="allocateButtons1Boolean"
                            style="padding-left:1.2rem;padding-right: 1.2rem;" [style.border-color]="backgroundColorButton" >Cancel</button>        
                        </div>
                    </div>
            </div>
           
    </div>

<!-- <div class="agGridOuterDiv" style="margin-top: 15px;">

    <mat-toolbar class="agGridtopersDiv card" style="
        background: rgb(228 227 230 / 41%);border-top: 1px solid #a9a9a9a8;
        border-right: 1px solid #a9a9a9a8;border-left: 1px solid #a9a9a9a8;">
        <label i18n="@@spmsUserReg" style="color: gray;">Filters For Dataset</label>

        <span class="example-spacer"></span>

        <div class="insertPageNoDiv">
            <mat-form-field appearance="outline">
                <mat-label i18n="@@Targetpageno">Page No</mat-label>
                <input matInput type="text" (input)="onSearchChange($event.target.value)">
            </mat-form-field>
        </div>
        <div class="selectRecordsDiv" style="width:9.5%">
            <mat-form-field appearance="outline" style="width:100%">
                <mat-label i18n="@@Targetrecords" style="color:black">Records</mat-label>
                <mat-select [(ngModel)]="pageSize" (ngModelChange)="onPageSizeChanged()">
                    <mat-option value="10" selected>10</mat-option>
                    <mat-option value="200">200</mat-option>
                    <mat-option value="300">300</mat-option>
                    <mat-option value="400">400</mat-option>
                </mat-select>

            </mat-form-field>
        </div>
        <div class="card pagination paginationFirstButton paginationFirstlastButton">
            <em class="fas fa-angle-double-left waves-effect waves-light" (click)="onBtFirst()"></em>
        </div>
        <div class="card pagination paginationButtons btn-rounded">
            <ul>
                <li class="paginationliicon"><em class="fas fa-angle-left waves-effect waves-light"
                        (click)="onBtPrevious()"></em></li>
                <li>{{currentPage}}/{{totalPages}}</li>
                <li class="paginationliicon" style="padding:0;"><em
                        class="fas fa-angle-right waves-effect waves-light" (click)="onBtNext()"></em></li>
            </ul>
        </div>
        <div class="card pagination paginationLastButton paginationFirstlastButton">
            <em class="fas fa-angle-double-right waves-effect waves-light" (click)="onBtLast()"></em>
        </div>
    </mat-toolbar>
    <ag-grid-angular class="ag-theme-balham table-width-static-fulfilment-return tablestyles square scroolbar-dusty-grass square thin"
    [columnDefs]="columnDefs" [animateRows]="true"  [pagination]="true" [rowSelection]="rowSelection" [defaultColDef]="defaultColDef"
    [suppressPaginationPanel]="true" [rowHeight]="35" [headerHeight]="35" [enableBrowserTooltips]="true"
    [floatingFiltersHeight]="45" [paginationPageSize]="paginationPageSize"
    [paginationNumberFormatter]="paginationNumberFormatter" [enableRangeSelection]="true" [debug]="true"
    [rowClassRules]="rowClassRules" (paginationChanged)="onPaginationChanged()"
    [components]="components" (gridReady)="onGridReady($event)" (click)="onSelectionChanged()"
    [hidden]="!true">
</ag-grid-angular>

<div style="text-align: end;margin-top: 5px;margin-bottom: 8px;">
        <button i18n="@@TargetCancel" type="button" (click)="closePopup()"
        class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton"
        style="padding: .3rem 1.6rem;font-size: .85rem;width:95px;color: white;" >Close</button>
</div>

</div> -->


